import { getShellLogger } from './logger'

let appVersion = '0.0.0-development-SNAPSHOT'

export const setHostAppVersion = (version: string) => {
  appVersion = version
  getShellLogger().log(`Host Application version: ${version}`)
}

export const getHostAppVersion = () => appVersion
